import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-upload-files-header',
  templateUrl: './upload-files-header.component.html',
  styleUrls: ['./upload-files-header.component.scss'],
})
export class UploadFilesHeaderComponent {
  @Input() title = '';
  @Input() description ='';
}
